import React from "react";

const Input = ({
    label,
    type = "text",
    placeholder = "",
    value,
    checked,
    onChange,
    name,
    disabled = false,
    required = false,
    style = {},
    isdark,
    iscolour,
    iscolourDark,
}) => {
    return (
        <>
            <style>
                {`
                .search-input::placeholder {
                    color: ${isdark === "light" ? "#A9A9A9" : "#8F8F8F"} !important;
                    opacity: 1;
                }

                .search-input:focus {
                    border-color: ${isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour5
                    } !important;

                    box-shadow: 0 0 0 0.2rem ${isdark === "light"
                        ? `${iscolour?.Colour6}40`
                        : `${iscolourDark?.Colour1}40`
                    } !important;
                }

                .custom-radio, .custom-checkbox {
                    width:18px;
                    height:18px;
                    cursor:pointer;
                    accent-color:${isdark === "light"
                        ? iscolour?.Colour8
                        : iscolourDark?.Colour4
                    };
                }

       
               
                `}
            </style>

            {type === "radio" || type === "checkbox" ? (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "28px",
                    }}
                >
                    <input
                        type={type}
                        className={type === "radio" ? "custom-radio" : "custom-checkbox"}
                        name={name}
                        checked={checked}
                        onChange={onChange}
                        disabled={disabled}
                    />

                    <label
                        style={{
                            margin: 0,
                            fontWeight: "600",
                            color:
                                isdark === "light"
                                    ? iscolour?.Colour9
                                    : "#fff",
                            cursor: "pointer",
                        }}
                    >
                        {label}
                    </label>
                </div>
            ) : (
                <div style={{ width: "100%" }}>
                    {label && (
                        <label
                            style={{
                                color:
                                    isdark === "light"
                                        ? iscolour?.Colour9
                                        : "#fff",
                                fontWeight: "700",
                                fontSize: "13px",
                            }}
                            className="pb-1"
                        >
                            {label}
                        </label>
                    )}

                    <input
                        type={type}
                        name={name}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                        disabled={disabled}
                        className="search-input"
                        style={{
                            width: "100%",
                            padding: "12px 20px",
                            border: "none",
                            borderRadius: "12px",
                            outline: "none",
                            fontSize: "16px",
                            color:
                                isdark === "light"
                                    ? iscolour?.Coloured12
                                    : "#fff",
                            background:
                                isdark === "light"
                                    ? iscolour?.Colour5
                                    : iscolourDark?.Colour9,
                            ...style,
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default Input;